import globals from 'application/constants/globals'
import React from 'react'
import { Container, Card } from 'react-bootstrap'

interface IInputProps {
  pdf: boolean
  title: string
  includeContainer: boolean //Required for proposal + PDF views, not for estimate details
}

const Content = (props: IInputProps) => {
  return (
    <Card className={props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem'}>
      <Card.Header
        className={
          props.pdf
            ? 'border-bottom-0 background-green pdf-card'
            : 'border-bottom-0 background-green'
        }
      >
        <div className="text-header text-green">{props.title}</div>
      </Card.Header>
      <Card.Body>
        <h4>Requirements for PHEVs to Qualify for the EV Discount:</h4>
        <p>Any PHEV leases entered after 1 April 2025 are not eligible for any exemption, and the 20% statutory fraction will apply.</p>
        
        <h4 className = "mt-3" >Information for all EVs:</h4>
        <ol className="pl-3">
          <li>
            As you have selected an eligible vehicle under the fuel efficient
            luxury car tax threshold for the current financial year, you are
            eligible for an exemption from Fringe Benefits Tax, which would
            normally be associated when salary packaging a novated lease.
          </li>
          <li className="mt-2">
            The Federal Government is currently reviewing the EV FBT exemption, 
            with the review expected to conclude by mid-2027. MyCar/Customer Care 
            team will contact you with updates if any changes to the exemption occur.
          </li>
          <li className="mt-2">
            While eligible vehicles may be exempt from FBT, your employer will
            show the lease as a Reportable Fringe Benefit (should you choose to
            use the exemption) on your annual payment summary.
          </li>
          <li className="mt-2">
            Reportable Fringe Benefits may impact some income tested government
            assistance and concessions. Click{' '}
            <a
              href={globals.isBrandMX ? "https://www.maxxia.com.au/faq" : "https://www.remserv.com.au/faq" }
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark text-underline font-weight-bold"
            >
              here
            </a>{' '}
            for more information.
          </li>
        </ol>
      </Card.Body>
    </Card>
  )
}

const RfbaSection = (props: IInputProps) => {
  if (props.includeContainer)
    return (
      <div className="card-section print-page-break-before">
        <Container className="section mt-4">
          <Content {...props} />{' '}
        </Container>
      </div>
    )
  else return <Content {...props} />
}

export default RfbaSection
